import React from "react";

const PomodoroIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      height="48"
      width="48"
      class="h-[20px] w-[20px]"
    >
      <g>
        <path
          d="M41.36 15.58a10.36 10.36 0 0 1 -2.38 0.96 10.14 10.14 0 0 1 0.26 6 3 3 0 0 1 -2.84 2 3.06 3.06 0 0 1 -0.6 0 20.54 20.54 0 0 1 -6.46 -2.76 15.58 15.58 0 0 1 -3.22 5.32 3 3 0 0 1 -4.24 0 15.58 15.58 0 0 1 -3.22 -5.3 20.54 20.54 0 0 1 -6.46 2.76 3.06 3.06 0 0 1 -0.6 0 3 3 0 0 1 -2.84 -2 10.24 10.24 0 0 1 0.26 -6 10.92 10.92 0 0 1 -2.4 -0.96A19.02 19.02 0 0 0 2 28c0 12.9 7.82 20 22 20s22 -7.1 22 -20a18.92 18.92 0 0 0 -4.64 -12.42Zm-13.54 24c4.74 -0.6 7.68 -3.48 7.68 -7.52a1.5 1.5 0 0 1 3 0c0 5.58 -4 9.7 -10.32 10.48H28a1.5 1.5 0 0 1 -1.48 -1.32 1.48 1.48 0 0 1 1.3 -1.7Z"
          fill="currentColor"
          stroke-width="1"
        ></path>
        <path
          d="M22 7.52a14.72 14.72 0 0 0 -3.34 -0.36A23.74 23.74 0 0 0 6 11.48 9.32 9.32 0 0 0 12 14a7.6 7.6 0 0 0 1.86 -0.22c-3.38 4.5 -2.24 7.88 -2.24 7.88A16.42 16.42 0 0 0 20.62 16 13.5 13.5 0 0 0 24 25 13.5 13.5 0 0 0 27.38 16a16.42 16.42 0 0 0 9 5.64s1.14 -3.38 -2.24 -7.88A7.6 7.6 0 0 0 36 14a9.32 9.32 0 0 0 6 -2.48 23.74 23.74 0 0 0 -12.68 -4.32 14.72 14.72 0 0 0 -3.32 0.32V2a2 2 0 0 0 -4 0Z"
          fill="currentColor"
          stroke-width="1"
        ></path>
      </g>
    </svg>
  );
};

export default PomodoroIcon;
